import Vue from 'vue'
import App from './App.vue'
import router from './router' // 引入路由

Vue.config.productionTip = false

// public/frontend-overlay/jjj-questionnaire 是跑在应用之外的 overlay 脚本，它要自己
// 画预警地图，需要拿到 echarts。原实现是猜 webpack module id（req(2000)）去捞，那个 id
// 随构建而变、实测已失效。这里给一个稳定的取用入口，保持懒加载、不进主包。
window.__jjjLoadEcharts = () => import('echarts')

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
